import { createThrowBombOutbound } from '../api/outbound/pokerOutbounds';
export function throwBomb({ targetUsername, bombType, socketSend, numberOfBombs }) {
    socketSend(createThrowBombOutbound(targetUsername, bombType, numberOfBombs));
    // TODO: Record a stat about which control (uiControlType) was used to throw each bomb, to get a sense of bomb control type popularity.
}
